exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Card-module__wrapper___2A5f7{background-color:#fff;min-height:75px;max-width:850px;width:100%;border-radius:10px}", ""]);

// exports
exports.locals = {
	"wrapper": "Card-module__wrapper___2A5f7"
};